export const queryKeys = {
  getLootBoxData: "getLootBoxData",
  deleteUser:"deleteUser"
};

export const endPoint = "https://api-lootbox.katanainu.com";
